import { render, staticRenderFns } from "./IdCardAuthSignature.vue?vue&type=template&id=68d8b49a&scoped=true&"
import script from "./IdCardAuthSignature.vue?vue&type=script&lang=js&"
export * from "./IdCardAuthSignature.vue?vue&type=script&lang=js&"
import style0 from "./IdCardAuthSignature.vue?vue&type=style&index=0&id=68d8b49a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d8b49a",
  null
  
)

export default component.exports